import { QueryClient } from "@tanstack/react-query";

export const QUERY_OPTIONS = {
  staleTime: 5 * 60 * 1000,
  retry: false as const,
  refetchOnMount: false as const,
  refetchOnWindowsFocus: false as const,
  refetchOnReconnect: true as const,
  refetchIntervalInBackground: true as const,
  refetchInterval: false as const,
};

// The query client.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: QUERY_OPTIONS,
  },
});

// Types: everywhere we expect an ID, it should be a number but can also be undefined or null
// An ID with value 0 is considered the same as null or undefined!
export type ID = number | null | undefined;

export type Params = Record<string, string | number>;
